import { create } from "zustand";

import type { StipulationCategory } from "./stipulationCategoryFilters";
import { ALL_STIPULATION_CATEGORIES, DEFAULT_STIPULATION_CATEGORY } from "./stipulationCategoryFilters";

type CategoryFilter = StipulationCategory | typeof ALL_STIPULATION_CATEGORIES;

interface StipulationCategoryState {
  /** The active category filter — a `StipulationCategory` code or the "all" sentinel. */
  category: CategoryFilter;
  /** Sets the active category filter. Driven by both the manual dropdown and scroll-spy. */
  setCategory: (category: CategoryFilter) => void;
  /** Resets to the default category (e.g. on deal switch). */
  reset: () => void;
}

/**
 * Shared category filter for the Stipulations panel. Lives outside the panel
 * component so the Signers card's scroll-spy (a sibling in the layout) can
 * drive it directly as the analyst scrolls through Income/Bank/Residence.
 */
export const useStipulationCategoryStore = create<StipulationCategoryState>((set) => ({
  category: DEFAULT_STIPULATION_CATEGORY,
  setCategory: (category) => set({ category }),
  reset: () => set({ category: DEFAULT_STIPULATION_CATEGORY }),
}));
